import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import searchEngine from "../Asset/ESO/search-engine.svg";
import FileNamesvg from "../Asset/esocardicon/FileAccessibilityReport/FileName.svg"
import Scoresvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg"
import Grid from '@mui/material/Grid';
import AccordionActions from '@mui/material/AccordionActions';
import Button from '@mui/material/Button';
import {Container, Box, Badge} from '@mui/material';
import Commoncard from "../Commoncard";

const PdfFile = React.memo((props) => {
  const [childcardData, setChildcardData] = useState([]);
  const [expanded, setExpanded] = useState('panel-0');
 const handleChange = (panel) => (event, isExpanded) => {
  setExpanded(isExpanded ? panel : false);
};

const [success, setSuccess] = useState('panel1-0');
const handleChanges = (panelId) => (event, isExpanded) => {
  setSuccess(isExpanded ? panelId : false);
};

  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const { jobid } = useParams();

  useEffect(() => {
    setChildcardData(props.cardData);
  }, [props.cardData]);

const successRows = useMemo(() => (
  childcardData.detailed_data?.success?.map((row, index) => {
    const panelId = `panel1-${index}`;
    return (
      <div key={index} className="success_row">
        <Accordion
          expanded={success === panelId}
          onChange={handleChanges(panelId)}
          className="success_accordion"
        >
          <AccordionSummary
            className="success_summary"
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-content-${index}`}
            id={`panel-header-${index}`}
          >
            <div component="span" className="success_title">{row.title}</div>
          </AccordionSummary>
          <AccordionDetails className="success_details">
            <p><strong style={{ color: '#ff601f' }}>Requirement:</strong> {row.requirement}</p>
            <p><strong style={{ color: '#ff601f' }}>Response:</strong> {row.response}</p>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  })
), [childcardData.detailed_data?.success, success]);


  // const failureRows = useMemo(() => (
  //   childcardData.detailed_data?.failure?.map((row, index) => (
  //     <div key={index} style={{ marginLeft: "30px" }}>
  //       <span><b><h3>{row.title}</h3></b></span>
  //       <p><strong>Requirement:</strong> {row.requirement}</p>
  //       <p><strong>Response:</strong> {row.response}</p>
  //     </div>
  //   ))
  // ), [childcardData.detailed_data?.failure]);

  const failureRows = useMemo(() => (
  childcardData.detailed_data?.failure?.map((row, index) => {
    const panelId = `panel-${index}`;
    return (
      <div key={index} className="success_row">
        <Accordion
          expanded={expanded === panelId}
          onChange={handleChange(panelId)}
          className="success_accordion"
        >
          <AccordionSummary
            className="success_summary"
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-content-${index}`}
            id={`panel-header-${index}`}
          >
            <div component="span" className="success_title">{row.title}</div>
          </AccordionSummary>
          <AccordionDetails className="success_details">
            <p><strong style={{ color: '#ff601f' }}>Requirement:</strong> {row.requirement}</p>
            <p><strong style={{ color: '#ff601f' }}>Response:</strong> {row.response}</p>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  })
), [childcardData.detailed_data?.failure, expanded]);


  const PdfFileCards = [
    {
      title: childcardData?.file_name,
      value: "File Name",
      iconSrc: FileNamesvg,
      bgColor: 1,
      iconColor: 1
    },
    {
      title: "Score",
      value: childcardData?.score,
      iconSrc: Scoresvg,
      bgColor: 2,
      iconColor: 2
    }
  ];


  return (
    <div className="cnt_hdr_file_access ">

      <Container maxWidth={false} className="dashboard-card-container">
        <Box>
          <Grid container>
            <Grid container spacing={3} justifyContent="center">
              {PdfFileCards.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Commoncard item={item} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>
      {/* <div className="common-card-container" style={{ justifyContent: "center" }}>
        <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }} >
          <div className={`common-card-icon-container`}>
            <div className={`common-card-icons`}>
              <img src={FileNamesvg} className={`common-card-icon-img`} alt="High Impact Issues" />
            </div>
          </div>
          <div className={`common-card-subtitle cardcontentactivecontainer`}>
            <span className="common-card-title">File Name</span>
            <span className="common-card-value">{childcardData.file_name}</span>
          </div>
        </div>
        <div className={`common-card-wrapper-style cardactivecontainer`} style={{ cursor: 'default' }} >
          <div className={`common-card-icon-container`}>
            <div className={`common-card-icons`}>
              <img src={Scoresvg} className={`common-card-icon-img`} alt="High Impact Issues" />
            </div>
          </div>
          <div className={`common-card-subtitle cardcontentactivecontainer`}>
            <span className="common-card-title">Score</span>
            <span className="common-card-value">{childcardData.score}</span>
          </div>
        </div>
      </div> */}

      <div className="" style={{padding:'50px 0px'}}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <div className="success_box">
              <h3 className="success_message">Success Report</h3>
          {successRows}
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="success_box">
              <h3 className="failure_message">Failure Report</h3>
          {failureRows}
            </div>
          </Grid>
        </Grid>
      </div>


      {/* <div className="cnt_hdr_content_table fileaccessreport_inner">
        <div className="box_wrap">
          <div className="hor_line">
            <center><h2>Success</h2></center>
          </div>
          {successRows}
        </div>
      </div>
      <div className="cnt_hdr_content_table fileaccessreport_inner">
        <div className="box_wrap">
          <div className="hor_line">
            <center><h2>Failure</h2></center>
          </div>
          {failureRows}
        </div>
      </div> */}
    </div>
  );
});

export default PdfFile;